import angarachickentikka from '../../img/desi/angarachickentikka.jpg';
import butterchicken from '../../img/desi/butterchicken.jpg';
import chatpatajeeraaloo from '../../img/desi/chatpatajeeraaloo.jpg';
import chilligarlicprawns from '../../img/desi/chilligarlicprawns.jpg';
import crispycorn from '../../img/desi/crispycorn.jpg';
import garlicnchickenseekh from '../../img/desi/garlicnchickenseekh.jpg';
import kasundifishtikka from '../../img/desi/kasundifishtikka.jpg';
import kurkuribhindimasala from '../../img/desi/kurkuribhindimasala.jpg';
import malaikoftacurry from '../../img/desi/malaikoftacurry.jpg';
import pannerelazeez from '../../img/desi/pannerelazeez.jpg';
import vegshammikebab from '../../img/desi/vegshammikebab.jpg';
import sweetspicywings from '../../img/desi/sweetspicywings.jpg';
import beanssproutsalad from '../../img/desi/beanssproutsalad.jpg';
import beetrootncarrotsalad from '../../img/desi/beetrootncarrotsalad.jpg';
import eggmasala from '../../img/desi/eggmasala.jpg';
import gardengreensalad from '../../img/desi/gardengreensalad.jpg';
import gulabjamun from '../../img/desi/gulabjamun.jpg';
import jeerarice from '../../img/desi/jeerarice.jpg';
import kesariphirnee from '../../img/desi/kesariphirnee.jpg';
import mangomousse from '../../img/desi/mangomousse.jpg';
import muttonrogani from '../../img/desi/muttonrogani.jpg';
import plainrice from '../../img/desi/plainrice.jpg';
import shahitukda from '../../img/desi/shahitukda.jpg';
import tandooripaneertikka from '../../img/desi/pannertikka.jpg';

// south  indian
import classicidli from '../../img/southindian/classicidli.jpg';
import dahivada from '../../img/southindian/dahivada.jpg';
import idiyappam from '../../img/southindian/idiyappam.jpg';
import lemonrice from '../../img/southindian/lemonrice.jpg';
import masaladosa from '../../img/southindian/masaladosa.jpg';
import paneerdosa from '../../img/southindian/paneerdosa.jpg';
import rasamrice from '../../img/southindian/rasamrice.jpg';
import ravaupma from '../../img/southindian/ravaupma.jpg';
import sambarvadai from '../../img/southindian/sambarvadai.jpg';
import tomatouthappam from '../../img/southindian/tomatouthappam.jpg';

// italian
import broccolilemonaglioolio from '../../img/Italian/broccolilemonaglioolio.jpg';
import bruschettatomatorocksalt from '../../img/Italian/bruschettatomatorocksalt.jpg';
import creamyrisotto from '../../img/Italian/creamyrisotto.jpg';
import mushroomchickencroustade from '../../img/Italian/mushroomchickencroustade.jpg';
import pennepestotomato from '../../img/Italian/pennepestotomato.jpg';
import pestoroastedchickensalad from '../../img/Italian/pestoroastedchickensalad.jpeg';
import prawnaglioolionew from '../../img/Italian/prawnaglioolionew.jpeg';
import spiedinitoscanachicken from '../../img/Italian/spiedinitoscanachicken.jpg';
import spinachmushroomandcornlasagna from '../../img/Italian/spinachmushroomandcornlasagna.jpg';
import twicebakedcheesesouffle from '../../img/Italian/twicebakedcheesesouffle.png';

// pizza 

import barbequechicken from '../../img/Pizza/barbequechicken.jpg';
import cheesepizza from '../../img/Pizza/cheesepizza.jpg';
import chickenfiesta from '../../img/Pizza/chickenfiesta.jpg';
import margherita from '../../img/Pizza/margherita.jpg';
import meatza from '../../img/Pizza/meatza.jpg';
import tomatopizza from '../../img/Pizza/tomatopizza.jpg';

// indian snacks

import chakli from '../../img/IndianSnacks/chakli.jpg';
import gobimanchurian from '../../img/IndianSnacks/gobimanchurian.jpg';
import harabharakabab from '../../img/IndianSnacks/harabharakabab.jpg';
import meduvada from '../../img/IndianSnacks/meduvada.jpg';
import ravadhokla from '../../img/IndianSnacks/ravadhokla.jpg';
import vadapav from '../../img/IndianSnacks/vadapav.jpg';
import vegspringroll from '../../img/IndianSnacks/vegspringroll.jpg';

// plantbased

import cauliflowertacos from '../../img/plantbased/cauliflowertacos.jpg';
import coconutspinachtempeh from '../../img/plantbased/coconutspinachtempeh.jpg';
import kashmirichickpeabowls from '../../img/plantbased/kashmirichickpeabowls.jpg';
import mediterraneancouscousbowls from '../../img/plantbased/mediterraneancouscousbowls.jpg';
import mediterraneanveggiesandwich from '../../img/plantbased/mediterraneanveggiesandwich.jpg';
import mungbeankitchari from '../../img/plantbased/mungbeankitchari.jpg';
import teriyakivegetable from '../../img/plantbased/teriyakivegetable.jpg';
import tofusaagpanner from '../../img/plantbased/tofusaagpanner.jpg';

// special menu

import chickenbiryani from '../../img/special_Item/chickenbiryani.jpg';
import creamydalmakhni from '../../img/special_Item/creamydalmakhani.jpg';
import lemonbread from '../../img/special_Item/lemonbread.jpg';
import muttonbiryani from '../../img/special_Item/muttonbiryani.jpg';
import samosa from '../../img/special_Item/samosa.jpg';
import vegbiryani from '../../img/special_Item/vegbiryani.jpg';




const Images = {
  angarachickentikka,
  butterchicken,
  beanssproutsalad,
  beetrootncarrotsalad,
  chatpatajeeraaloo,
  chilligarlicprawns,
  crispycorn,
  eggmasala,
  gardengreensalad,
  garlicnchickenseekh,
  gulabjamun,
  jeerarice,
  kasundifishtikka,
  kesariphirnee,
  kurkuribhindimasala,
  malaikoftacurry,
  mangomousse,
  muttonrogani,
  pannerelazeez,
  tandooripaneertikka,
  plainrice,
  shahitukda,
  vegshammikebab,
  sweetspicywings,

  // south Indian

  classicidli,
  dahivada,
  idiyappam,
  lemonrice,
  masaladosa,
  paneerdosa,
  rasamrice,
  ravaupma,
  sambarvadai,
  tomatouthappam,

  // Italian

  broccolilemonaglioolio,
  bruschettatomatorocksalt,
  creamyrisotto,
  mushroomchickencroustade,
  pennepestotomato,
  pestoroastedchickensalad,
  prawnaglioolionew,
  spiedinitoscanachicken,
  spinachmushroomandcornlasagna,
  twicebakedcheesesouffle,

  // pizza

  barbequechicken,
  cheesepizza,
  chickenfiesta,
  margherita,
  meatza,
  tomatopizza,

  // indian snacks
  chakli,
  gobimanchurian,
  harabharakabab,
  meduvada,
  ravadhokla,
  vadapav,
  vegspringroll,

  // plantbased


  cauliflowertacos,
  coconutspinachtempeh,
  kashmirichickpeabowls,
  mediterraneancouscousbowls,
  mediterraneanveggiesandwich,
  mungbeankitchari,
  teriyakivegetable,
  tofusaagpanner,

  // special item
  chickenbiryani,
  creamydalmakhni,
  lemonbread,
  muttonbiryani,
  samosa,
  vegbiryani

}

export default Images;